import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ModulesAdminPanel from "./ModulesAdminPanel";

const ModulesAdminPage = () => {
    const { classId, subjectSlug, authorSlug } = useParams();
    const nav = useNavigate();

    return (
        <ModulesAdminPanel
            classId={String(classId || "")}
            subjectSlug={String(subjectSlug || "")}
            authorSlug={String(authorSlug || "")}
            onBack={() =>
                nav(
                    `/manage-portal-9f3a/classes/${classId}/subjects/${subjectSlug}/authors`
                )
            }
            onEditModule={(moduleSlug) =>
                nav(
                    `/manage-portal-9f3a/classes/${classId}/subjects/${subjectSlug}/authors/${authorSlug}/modules/${moduleSlug}`
                )
            }
        />
    );
};

export default ModulesAdminPage;
